<template>
  <router-link to="/" class="logo-wrapper">
    <i class="zr-icons logo" :class="{dark}" />
    <!-- <div class="name">
      <p class="text">卓锐网络科技</p>
      <p class="sec-text">Zhou Rei Network Technology</p>
    </div> -->
  </router-link>
</template>

<script>
export default {
  name: 'logo',
  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() { }
}
</script>

<style lang="scss" scoped>
.logo-wrapper {
  display: flex;
  align-items: center;
  .logo {
    display: inline-block;
    width: 43.2vw;
    height: 10.6vw;
    background-size: 100% auto;
  }
  /* .name {
    margin-left: 2.66vw;
    .text {
      font-size: 4.2vw;
      font-family: MFDianHei_Noncommercial-ExBold, MFDianHei_Noncommercial;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 4.5vw;
      letter-spacing: 1px;
    }
    .sec-text {
      font-size: 1.86vw;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 2.4vw;
    }
  } */
}
</style>



// WEBPACK FOOTER //
// src/components/h5/logo/index.vue